import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signin.css';
import ENV from '../constants/env-constants';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from 'sweetalert2'
import Spinner from '../components/Spinner/Spinner';

function ResetPassword() {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get("token");
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Reset Password' });
    if (!token) navigate('/site/change-password')
  }, []);

  const forgotPasswordFieldValidationSchema = Yup.object().shape({
    password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long').max(20, 'Max Character limit reached'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm password is required'),
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    onSubmit: (values, ) => {
      handleSubmit(values);
    },
    validationSchema: forgotPasswordFieldValidationSchema
  });

  const handleSubmit = async ({password}) => {
    setIsButtonLoading(true);
    try {
      const response = await fetch(`${ENV.API_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password, token }),
      });
      if (response.status === 200) {
        Swal.fire({
          text: "Your password has been updated!",
          icon: "success"
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/site/signin')
          }
        });;
      } else if (response.status === 500) {
        Swal.fire({
          title: "Server Error",
          icon: "error"
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Something went wrong",
        icon: "error"
      });
    }
    setIsButtonLoading(false);
  };

  return (
    <div className="center1">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Forgot Password</title>
        </Helmet>
        <div className="centercustom center">
          <h1>Reset Password</h1>
          <form onSubmit={formik.handleSubmit} className='form'>
            <div className="txt_field">
              <input name='password' type="password" className='custominput' value={formik.values.password} onChange={formik.handleChange} required  />
              <span />
              <label>Password</label>
            </div>
            <div className='formik_error'>{formik.errors.password}</div>
            <div className="txt_field">
              <input name='confirmPassword' type="password" className='custominput' value={formik.values.confirmPassword} onChange={formik.handleChange} required  />
              <span />
              <label>Confirm password</label>
            </div>
            <div className='formik_error'>{formik.errors.confirmPassword}</div>
            <div onClick={formik.handleSubmit} className='sign-in-submit-button' style={{height: '3rem', display: 'flex', justifyContent: 'center', padding: '0.5rem', alignItems: 'center'}}>
              {isButtonLoading ? <Spinner color="#2691d9"/> : 'Reset Password'}
            </div>
          </form>
        </div>
    </div>
  );
}

export default ResetPassword;